














import { Component, Prop } from "vue-property-decorator";

import { BaseBorderless } from "@share/common/form/form-controls/base/borderless/base-borderless";

import TimeSelector from "@share/common/controls/date/time-selector/TimeSelector.vue";
import DropdownList from "@share/common/drop-down/DropdownList.vue";
import { DropDownItem } from "@share/common/drop-down/types";
import { getTimeList } from "@common/dateTimeHelper";
import WatchIcon from "../../../../../../assets/svg/watch-icon.svg";

@Component({ components: { TimeSelector, DropdownList, WatchIcon }})

export default class TimeInput extends BaseBorderless {

  @Prop() declare value: string;

  showDropdown = false;
  list: DropDownItem[] = []

  created() {
    this.list = getTimeList(0, 24, 15).map((timeString) => ({ title: timeString, id: timeString }))
  }

  focus() {
    this.showDropdown = true
  }
}

